var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paypal_container"},[_c('PayPal',{staticClass:"fade",class:_vm.canPurchase() ? 'show' : '',attrs:{"offer":_vm.offer,"client":_vm.paypalConfig.credentials,"env":_vm.PAYPAL_ENV,"button-style":_vm.paypalConfig.style,"locale":_vm.locale},on:{"payment-authorized":_vm.paymentAuthorized,"payment-cancelled":_vm.paymentCancelled,"payment-error":_vm.paymentError,"button-loaded":_vm.buttonLoaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021105e9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/PaypalButton.vue
// module id = 1104
// module chunks = 0